/* eslint-disable no-console, eol-last, import/no-duplicates,  import/no-extraneous-dependencies, import/order */
import '@interactjs/auto-scroll/plugin'
import interact from '@interactjs/interact/index'
import plugin from '@interactjs/auto-scroll/plugin'
interact.use(plugin)